import { MaterialIcons } from '@expo/vector-icons';
import React from 'react';
import {
    Modal,
    ScrollView,
    TouchableOpacity,
    View
} from 'react-native';

import EngagementItem from '@/components/EngagementItem';
import { ThemedText } from '@/components/ThemedText';
import { Colors } from '@/constants/Colors';
import AppStyles from '@/constants/Styles';
import { useColorScheme } from '@/hooks/useColorScheme';

interface EngagementLimitDialogProps {
  visible: boolean;
  onClose: () => void;
  myActiveEngagements: any[];
  onLeaveEngagement: (engagementId: string) => void;
  leaving: string | null;
}

export default function EngagementLimitDialog({
  visible,
  onClose,
  myActiveEngagements,
  onLeaveEngagement,
  leaving
}: EngagementLimitDialogProps) {
  const colorScheme = useColorScheme() ?? 'light';
  const backgroundColor = Colors[colorScheme].background;
  const iconColor = Colors[colorScheme].icon;

  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={onClose}
    >
      <TouchableOpacity 
        style={{
          flex: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        activeOpacity={1}
        onPress={onClose}
      >
        <TouchableOpacity
          style={{
            backgroundColor: backgroundColor,
            borderRadius: 12,
            padding: 20,
            margin: 20,
            maxWidth: 600,
            width: '90%',
            maxHeight: '90%',
          }}
          activeOpacity={1}
          onPress={() => {}} // Prevent clicks on dialog content from closing it
        >
          <TouchableOpacity
            style={AppStyles.modalCloseButton}
            onPress={onClose}
            accessibilityLabel="Close dialog"
            accessibilityHint="Closes the engagement limit dialog"
          >
            <MaterialIcons name="close" size={20} color={iconColor} />
          </TouchableOpacity>
          <ScrollView 
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{ paddingBottom: 20 }}
          >
            <ThemedText style={{
              fontSize: 18,
              fontWeight: 'bold',
              marginBottom: 16,
              textAlign: 'center',
            }}>
              Engagement Limit Reached
            </ThemedText>
            
            <ThemedText style={{
              fontSize: 14,
              marginBottom: 20,
              textAlign: 'center',
              lineHeight: 20,
            }}>
              You can only be active in at most four engagements for this branch. If you want to join this engagement, please leave one of your current engagements.
            </ThemedText>

            <ThemedText style={{
              fontSize: 16,
              fontWeight: '600',
              marginBottom: 12,
            }}>
              Your Current Engagements:
            </ThemedText>

            {myActiveEngagements && myActiveEngagements.map((engagement: any) => (
              <View key={engagement.engagement_id} style={{ marginBottom: 16 }}>
                <EngagementItem 
                  engagement={engagement}
                  showProgressBars={true}
                  showStats={true}
                  style={{ marginBottom: 0 }}
                />
                  <TouchableOpacity
                    style={{
                      backgroundColor: '#dc3545',
                      paddingHorizontal: 20,
                      paddingVertical: 12,
                      borderRadius: 8,
                      marginTop: 12,
                      alignSelf: 'flex-end',
                      minWidth: 80,
                    }}
                    onPress={() => onLeaveEngagement(engagement.engagement_id)}
                    disabled={leaving === engagement.engagement_id}
                  >
                    <ThemedText style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>
                      {leaving === engagement.engagement_id ? 'Leaving...' : 'Leave'}
                    </ThemedText>
                  </TouchableOpacity>
              </View>
            ))}

            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 20 }}>
              <TouchableOpacity
                style={{
                  backgroundColor: '#6c757d',
                  paddingHorizontal: 20,
                  paddingVertical: 12,
                  borderRadius: 8,
                  flex: 1,
                  marginRight: 8,
                }}
                onPress={onClose}
              >
                <ThemedText style={{ color: 'white', textAlign: 'center', fontWeight: '600' }}>
                  Cancel
                </ThemedText>
              </TouchableOpacity>
            </View>
          </ScrollView>
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  );
}
